/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowFigureACircleDownIcon16Light = forwardRef('ArrowFigureACircleDownIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M7.5 4a.5.5 0 0 1 .5.5v5.119l1.616-1.94a.5.5 0 0 1 .768.641l-1.732 2.078a1.5 1.5 0 0 1-2.304 0L4.616 8.32a.5.5 0 1 1 .768-.64L7 9.619V4.5a.5.5 0 0 1 .5-.5Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.5 1a6.5 6.5 0 1 1 0 13 6.5 6.5 0 0 1 0-13ZM13 7.5a5.5 5.5 0 1 0-11 0 5.5 5.5 0 0 0 11 0Z" })));
});
